"use client"

import { Download, X } from "lucide-react"
import { useEffect } from "react"
import "./css/porta.css"

const PdfModal = ({ isOpen, pdfPath, title, onClose }) => {
  console.log("📄 PdfModal renderizado con props:", { isOpen, pdfPath, title })

  // Prevenir scroll del body cuando el modal está abierto
  useEffect(() => {
    if (isOpen) {
      console.log("📄 Modal abierto - bloqueando scroll")
      document.body.style.overflow = "hidden"
    } else {
      console.log("📄 Modal cerrado - restaurando scroll")
      document.body.style.overflow = "unset"
    }

    // Cleanup al desmontar el componente
    return () => {
      document.body.style.overflow = "unset"
    }
  }, [isOpen])

  // Cerrar modal con tecla Escape
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        console.log("📄 Escape presionado - cerrando modal")
        onClose()
      }
    }

    if (isOpen) {
      document.addEventListener("keydown", handleEscape)
    }

    return () => {
      document.removeEventListener("keydown", handleEscape)
    }
  }, [isOpen, onClose])

  if (!isOpen || !pdfPath) {
    console.log("📄 Modal NO se muestra - isOpen:", isOpen, "pdfPath:", pdfPath)
    return null
  }

  console.log("📄 Modal SE MUESTRA")

  return (
    <div className="porta-modal-overlay" onClick={onClose}>
      <div className="porta-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="porta-modal-header">
          <h3>{title}</h3>
          <div className="porta-modal-actions">
            <a
              href={pdfPath}
              download={`${title.toLowerCase().replace(/\s+/g, "-")}.pdf`}
              className="porta-modal-download-button"
            >
              <Download size={20} /> Descargar
            </a>
            <button className="porta-modal-close" onClick={onClose}>
              <X size={24} />
            </button>
          </div>
        </div>
        <div className="porta-modal-body">
          <iframe src={pdfPath} width="100%" height="100%" title={`${title} PDF`} frameBorder="0" />
        </div>
      </div>
    </div>
  )
}

export default PdfModal
